import { useEffect, useState } from "react";
import "./SquarePaymentForm.css"

const appId = "sq0idp-rSubymCWY32C-lcptojsSA";
const locationId = "LRQ9HMBW4MQHD";

interface PaymentProps {
  customerId: string;
  orderId: string;
  totalAmount: number;
  nextStep: () => void;
  data: any;
}

const PaymentComponent = ({customerId,orderId, totalAmount, nextStep, data}:PaymentProps) => {
  const [payments, setPayments] = useState<any>(null);
  const [card, setCard] = useState<any>(null);
  const [status, setStatus] = useState<"SUCCESS" | "FAILURE" | "">("");
  const [amount, setAmount] = useState<number>(totalAmount); // Amount in cents (2 EUR = 200 cents)

  useEffect(() => {
    const loadSquare = async () => {
      if (!window.Square) {
        console.error("Square.js failed to load properly");
        return;
      }
      try {
        const paymentsInstance = window.Square.payments(appId, locationId);
        setPayments(paymentsInstance);

        // Attach card form
        const cardInstance = await paymentsInstance.card();
        const cardContainer = document.getElementById("card-container");
        if (cardContainer) {
          await cardInstance.attach(cardContainer);
        }
        setCard(cardInstance);

      } catch (error) {
        console.error("Error initializing Square payments", error);
      }
    };
    loadSquare();
  }, []);

  const createPayment = async (cardToken: string, verificationToken: string) => {
    const data = new URLSearchParams();
    data.append("locationId", locationId);
    data.append("sourceId", cardToken);
    data.append("verificationToken", verificationToken);
    data.append("amount", amount.toString());
    data.append("customerId", customerId);
    data.append("orderId", orderId);

    const response = await fetch("/backend/payment.php", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: data.toString(),
    });

    if (!response.ok) throw new Error("Payment failed");
    return response.json();
  };

  const handlePayment = async (paymentMethod: any) => {
    try {
      // 1️⃣ Tokenisation de la carte
      const tokenResult = await paymentMethod.tokenize();
      if (tokenResult.status !== "OK") {
        throw new Error("Erreur de tokenisation");
      }

      // 2️⃣ Vérification SCA (3D Secure / Securipass)
      const verificationDetails = {
        amount: (amount / 100).toFixed(2), // "10.00"
        currencyCode: "EUR",
        intent: "CHARGE",
        billingContact: {
          givenName: data?.prenom || "Client",
          familyName: data?.nom || "Inconnu",
          email: data?.email || "client@example.com",
          country: "FR",
        },
      };

      const verificationResult = await payments.verifyBuyer(
        tokenResult.token,
        verificationDetails
      );

      // ⚠️ Square renvoie { token: "verf:xxxx" } dans verificationResult.token
      if (!verificationResult?.token) {
        throw new Error("La vérification 3D Secure n’a pas renvoyé de token.");
      }

      // 3️⃣ Envoi des DEUX tokens au backend
      const response = await createPayment(
        tokenResult.token,            // Token de la carte (cnon:xxxx)
        verificationResult.token      // Token de vérification SCA (verf:xxxx)
      );

      console.log("✅ Paiement réussi :", response);
      setStatus("SUCCESS");
      nextStep();
    } catch (error) {
      console.error("❌ Erreur de paiement :", error);
      setStatus("FAILURE");
    }
  };

  return (
    <div>
      <form id="payment-form">
        <div id="google-pay-button"></div>
        <div id="card-container"></div>
        <button className="google-button" type="button" onClick={() => card && handlePayment(card)}>
          Payer {(amount/100).toFixed(2)} €
        </button>
      </form>
      {status && <div className={status === "SUCCESS" ? "success" : "failure"}>{status}</div>}
    </div>
  );
};

export default PaymentComponent;
